/* eslint-disable import/prefer-default-export */
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

function getTopicsDescriptionHeaderByTestType(totalTopics: number, testType: TestTypes): string {
    switch (testType) {
        case TestTypes.Aptitude:
            return `${totalTopics} ${UIStrings.CognitiveAbilityModules}:`;
        case TestTypes.EmotionalIntelligence:
        case TestTypes.Personality:
            return `${totalTopics} ${UIStrings.CharacteristicsIncluding}:`;
        case TestTypes.Skills:
            return `${totalTopics} ${UIStrings.Modules}:`;
        default:
            throw new Error(`Test type '${testType}' is not supported`);
    }
}

export { getTopicsDescriptionHeaderByTestType };
